import ModalLinkController from "./modal_link_controller"

export default class extends ModalLinkController
  @targets: ["npiNumberField"]

  _additionalCallbacks: ->
    @modalInstance.$wrapper.one 'click', 'button[data-remodal-confirm-with-data]', (event) =>
      value = event.currentTarget.dataset.remodalConfirmWithData
      @npiNumberFieldTarget.value = value
      App.Mixins.HighlightEffect.successHighlight($(@npiNumberFieldTarget))
      @modalInstance.close()